import { useStableObject } from '@atlassian/post-office-context/use-stable-object';
import { PlacementProvider } from '@atlassian/post-office-context/placement-context';

import type { PlacementProviderProps } from './types';
import type { StableProvider } from '../../types';

export const StablePlacementProvider: StableProvider<PlacementProviderProps> = ({
	children,
	placement,
}) => {
	const stableValue = useStableObject(placement);

	return <PlacementProvider value={stableValue}>{children}</PlacementProvider>;
};
